module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAdCAYAAACqhkzFAAAAAXNSR0IArs4c6QAAARJJREFUSEvtldFNwzAQhv+TB6BMQEfAyvkZukE7AR2BDWg3YASYgG5A3u3IjEAnoAxgHboIi4JKYvOGlJP8EPnuO/vyJz8BQIzxMqV0B2Cpz5WxM8ZsrbUvWkefsGcAs0rQcfrBGLNQKHnvWyK6OgUzxpxbaw95L8Y4Sym9/dK4ZeYFhRBk4GSvAHTlmAPQdTKYmcaAVVP4CXwUkYcqgr4EojWAG637BhSRrXNuUwv03m+ISBUyAacZlspnks3Xz2H69EpVg38sm+I7DiSWesqKmXchBPXsp6HGGaiudjHkZHlvxCH3zDxX1xvrXHrCPo+0e9d1axG5B3D2h1m+E9Ft0zS9Y/bAHN7761qgc649rvkAosgrLYRNbb4AAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/preview/phone.png
// module id = 2j8y
// module chunks = 1